<script lang="ts">
  import Icon from './Icon.svelte';
  import { TG_SUB_LINK } from '../lib/bot-links';
  import { openBotLink } from '../lib/telegram';

  // Reusable upsell banner shown on locked groups / materials. Single CTA →
  // TG_SUB_LINK (product decision). `compact` trims padding for inline use
  // above a material list.
  interface Props {
    title?: string;
    text?: string;
    cta?: string;
    compact?: boolean;
  }
  let {
    title = 'Цей розділ поки закритий',
    text = 'Для доступу до цього розділу активуйте підписку.',
    cta = 'Отримати повний доступ',
    compact = false,
  }: Props = $props();
</script>

<div class="lock" class:compact>
  <div class="lock-icon"><Icon name="lock" size="xl" /></div>
  <div class="lock-title">{title}</div>
  <div class="lock-text">{text}</div>
  <a href={TG_SUB_LINK} target="_blank" rel="noopener" class="lock-cta" onclick={(e) => openBotLink(e, TG_SUB_LINK)}>{cta}</a>
</div>

<style>
  .lock {
    background: linear-gradient(135deg, var(--dark) 0%, var(--dark3) 60%, var(--pu3) 100%);
    border-radius: 14px;
    padding: 32px 24px;
    text-align: center;
    color: var(--text-light);
    position: relative;
    overflow: hidden;
    margin-bottom: 18px;
  }
  .lock.compact {
    padding: 20px 18px;
  }
  .lock::after {
    content: '';
    position: absolute;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: rgba(251, 246, 236, 0.05);
    right: -40px;
    top: -40px;
  }
  .lock-icon {
    font-size: 32px;
    margin-bottom: 10px;
  }
  .lock-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 6px;
    position: relative;
    z-index: 1;
  }
  .lock-text {
    font-size: 12px;
    opacity: 0.75;
    margin-bottom: 18px;
    line-height: 1.5;
    position: relative;
    z-index: 1;
  }
  .lock-cta {
    display: inline-block;
    /* Блок завжди темний (градієнт Чорнило→Глина), тому кнопка тримає
       константні кольори, а не токени теми: --on-pu і --dark однакові
       вдень і вночі, а --bg/--text перевернулись би разом із темою. */
    background: var(--on-pu);
    color: var(--dark);
    padding: 11px 22px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
    position: relative;
    z-index: 1;
  }
</style>
